"use strict";

module.exports = function dragOver() {
  return {
    on: 'dragover dragenter dragleave dragend drop',
    getValue: function getValue(_ref) {
      var domEvent = _ref.domEvent;
      var eventType = domEvent && domEvent.type;
      return eventType === 'dragover' || eventType === 'dragenter';
    },
    setValue: null
  };
};